import { render, staticRenderFns } from "./NewOffsetTransactionPage.vue?vue&type=template&id=18a710f2&scoped=true"
import script from "./NewOffsetTransactionPage.vue?vue&type=script&lang=js"
export * from "./NewOffsetTransactionPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a710f2",
  null
  
)

export default component.exports